<template>
  <section>
    <div class="container clearfix py-5">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 col-12">
          <h1>Neler Yaptık?</h1>
          <h2>Şirketlerin TCE Politika Göstergelerinde Durum</h2>
          <div class="table-responsive">
            <table class="table table-striped">
              <tr>
                <td>TCE Strateji Belgesi yayınlayan şirketler</td>
                <th>
                  <h4 class="mb-0">0,5 %</h4>
                </th>
              </tr>
              <tr>
                <td>
                  Kadın yöneticilerin arttırılması için politika izleyen
                  şirketler
                </td>
                <th>
                  <h4 class="mb-0">8,33 %</h4>
                </th>
              </tr>
              <tr>
                <td>Kadın çalışanları gözeten uygulamaları olan şirketler</td>
                <th>
                  <h4 class="mb-0">58,33 %</h4>
                </th>
              </tr>
              <tr>
                <td>
                  Annelere, çocuklarıyla ilgili izinlerinde (hastalık, okul
                  etkinliği) kolaylık sağlayan şirketler
                </td>
                <th>
                  <h4 class="mb-0">16.67 %</h4>
                </th>
              </tr>
              <tr>
                <td>Kadınlara yönelik eğitim yapan şirketler</td>
                <th>
                  <h4 class="mb-0">16.67 %</h4>
                </th>
              </tr>
            </table>
          </div>
          <ul class="lead pl-4">
            <li>
              Öncelikle her üye için durum tespiti yapıldı, rapor olarak tüm
              üyelerle paylaşıldı.
            </li>
            <li>
              Üyeler, Toplumsal Cinsiyet Eşitliği konusunda kendi bünyelerinde
              ekip kurdu.
            </li>
            <li>
              Danışmanlar önderliğinde atanan ekiplerin katılımıyla Toplumsal
              Cinsiyet Eşitliği Workshop’u düzenlendi.
            </li>
            <li>
              Ayrıca Danışmanlar, üye şirketleri ziyaret ederek üst düzey
              yöneticiler ile görüştü.
            </li>
            <li>Ardından odak grup çalışmaları yapıldı.</li>
            <li>TCE stratejileri için raporlamalar tamamlandı.</li>
          </ul>
          <p class="lead mb-2">
            <b>İlham veren hikayeler:</b>
            <br />
            <b>Aromsa:</b> Anneler Günü’nde kadın emeğiyle üretilen ürünlerin
            dağıtılması
            <br />
            <b>Agritrade:</b> Turuncu Derneği kuruldu ve faaliyete geçti.
            <br />
            <b>Altunbilekler:</b> «Mutfak Anneleri» projesi
            <br />
            <b>Sodexo:</b> «Geleceğin Aşçıları» projesi «Toplumsal Cinsiyete
            Duyarlı Bütçeleme» uygulaması
            <br />
            <br />
          </p>
          <h2>Kadın Varlığı ve Etkinliği Göstergelerinde Durum</h2>
          <div class="table-repsonsive">
            <table class="table table-striped">
              <tr>
                <td class="text-white bg-danger">
                  Kadın çalışanları gözeten uygulamaları olan şirket oranı:
                </td>
                <th class="bg-danger">
                  <h4 class="mb-0 text-white">58.33 %</h4>
                </th>
              </tr>
              <tr>
                <td>Özel günleri hatırlayan şirketler:</td>
                <th>
                  <h4 class="mb-0">25.00 %</h4>
                </th>
              </tr>
              <tr>
                <td>Doğum ve süt izinlerini esnek şekilde veren şirketler:</td>
                <th>
                  <h4 class="mb-0">25.00 %</h4>
                </th>
              </tr>
              <tr>
                <td>
                  Annelere çocuklarıyla ilgili aldıkları izinlerde (hastalık,
                  okul etkinliği) kolaylık sağlayan şirketler:
                </td>
                <th>
                  <h4 class="mb-0">16.67 %</h4>
                </th>
              </tr>
              <tr>
                <td>Kadınlara yönelik eğitimler yapan şirketler:</td>
                <th>
                  <h4 class="mb-0">16.67 %</h4>
                </th>
              </tr>
              <tr>
                <td>
                  Kadın yöneticilerin arttırılması yönünde politika izleyen
                  şirketler:
                </td>
                <th>
                  <h4 class="mb-0">8.33 %</h4>
                </th>
              </tr>
            </table>
          </div>
          <p class="text-center">- * - * -</p>
          <div class="table-repsonsive">
            <table class="table table-striped">
              <tr>
                <td class="text-white bg-danger">
                  Kadınlara yönelik proje başlatan şirketler:
                </td>
                <th class="bg-danger">
                  <h4 class="mb-0 text-white">41.67 %</h4>
                </th>
              </tr>
              <tr>
                <td>Sosyal sorumluluk projeleri olan şirketler:</td>
                <th>
                  <h4 class="mb-0">16.67 %</h4>
                </th>
              </tr>
              <tr>
                <td>Özel projeler:</td>
                <th>
                  <h4 class="mb-0">16.67 %</h4>
                </th>
              </tr>
              <tr>
                <td>
                  İhbar hattı oluşturan/hatla ilgili kadın çalışanları
                  bilgilendiren şirketler
                </td>
                <th>
                  <h4 class="mb-0">8.33 %</h4>
                </th>
              </tr>
              <tr>
                <td>
                  Toplumsal cinsiyet eşitliği kurulu olan/kurulları aktif
                  çalışan şirketler:
                </td>
                <th>
                  <h4 class="mb-0">8.33 %</h4>
                </th>
              </tr>
            </table>
          </div>
          <p class="text-center">- * - * -</p>
          <div class="table-repsonsive">
            <table class="table table-striped">
              <tr>
                <td class="text-white bg-danger">
                  Kadın istihdamını destekleyen şirketler:
                </td>
                <th class="bg-danger">
                  <h4 class="mb-0 text-white">41.67 %</h4>
                </th>
              </tr>
              <tr>
                <td>İşe alımda pozitif ayrımcılık yapan şirketler:</td>
                <th>
                  <h4 class="mb-0">33.33 %</h4>
                </th>
              </tr>
              <tr>
                <td>
                  Kadın adaylara shortlistte yer verme politikası uygulayan
                  şirketler:
                </td>
                <th>
                  <h4 class="mb-0">8.33 %</h4>
                </th>
              </tr>
              <tr>
                <td>
                  Belirli departmanlarda kadın istihdamını arttırmaya yönelik
                  uygulamaları olan şirketler:
                </td>
                <th>
                  <h4 class="mb-0">8.33 %</h4>
                </th>
              </tr>
            </table>
          </div>
          <h2>Şirketlerde Kadın İstihdamında Durum</h2>
          <div class="table-responsive">
            <table class="table table-striped">
              <tr>
                <th class="bg-danger">
                  <h4 class="mb-0 text-white"></h4>
                </th>
                <th class="bg-danger">
                  <h4 class="mb-0 text-white">2018</h4>
                </th>
                <th class="bg-danger">
                  <h4 class="mb-0 text-white">2019</h4>
                </th>
                <th class="bg-danger">
                  <h4 class="mb-0 text-white">Fark</h4>
                </th>
              </tr>
              <tr>
                <td>A Grubu</td>
                <th>
                  <h4 class="mb-0">50,9 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">43,5 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">-7,4 %</h4>
                </th>
              </tr>
              <tr>
                <td>B Grubu</td>
                <th>
                  <h4 class="mb-0">38,3 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">41,7 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">3,4 %</h4>
                </th>
              </tr>
              <tr>
                <td>C Grubu</td>
                <th>
                  <h4 class="mb-0">30,9 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">31,8 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">0,9 %</h4>
                </th>
              </tr>
              <tr>
                <td>Ekosistem</td>
                <th>
                  <h4 class="mb-0">40,0 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">39,0 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">-1,0 %</h4>
                </th>
              </tr>
              <tr>
                <td>Türkiye</td>
                <th>
                  <h4 class="mb-0">29,3 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">28,9 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">-1,0 %</h4>
                </th>
              </tr>
              <tr>
                <td>B Grubu Yönetim Kurulu</td>
                <th>
                  <h4 class="mb-0">41,7 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">56,0 %</h4>
                </th>
                <th>
                  <h4 class="mb-0">14,3 %</h4>
                </th>
              </tr>
            </table>
          </div>
          <div class="table-responsive">
            <table class="table table-sm">
              <tr>
                <th>A Grubu</th>
                <td>
                  Mavi yakalı çalıştırmayan (ya da çok az, şoför, hizmet
                  görevlisi gibi) ve İK sayısı az olan şirketler
                </td>
              </tr>
              <tr>
                <th>B Grubu</th>
                <td>
                  Mavi yakalı çalıştıran fakat beyaz yakalı çalışan nüfusu da
                  yüksek (%30'un üzerinde) olan şirketler
                </td>
              </tr>
              <tr>
                <th>C Grubu</th>
                <td>
                  Beyaz yakalı oranı %30'un altında olan mavi yakalı ağırlıklı
                  şirketler
                </td>
              </tr>
            </table>
          </div>
          <p class="lead mb-0">
            <b>Aynı dönemde;</b>
          </p>
          <ul class="lead pl-4">
            <li>
              Türkiye genelinde işsizlik oranı
              <b>%3,4</b> arttı.
            </li>
            <li>
              Kadınların istihdam oranı bir yıl içerisinde
              <b>%29,8’den</b>, <b>%29,2’ye</b> düştü.
            </li>
            <li>
              Kadınların işsizlik oranı
              <b>%12,3’ten</b>
              <b>%15,2’ye</b> çıktı.
            </li>
          </ul>
          <h2>Son 2 yıl</h2>
          <p class="text-justify lead mb-2">
            <b>Agritrade</b>
            <br />
            <br />Agritrade yönetim kurulu başkanı Işınsu Kestelli’nin
            başkanlığını yürüttüğü Turuncu Dernek kuruldu. Turuncu Dernek,
            toplumsal cinsiyet eşitliğinin sağlanması ve kadınlar ile çocuklar
            başta olmak üzere mülteciler, LGBTİ bireyler ve toplumdaki
            dezavantajlı grupların sosyoekonomik statülerinin gelişmesi için
            çalışmalar ve projeler yürütecek.
            <br />
            <br />Dernek çalışmalarına hemen başladı; eşitlik, şiddet, taciz,
            pedofili, ensest, erkeklik, mülteci sorunları konularında
            konuşmaların yer aldığı Turuncu Konuşmalar etkinliği düzenledi.
            erneğin projelerinden ‘Turuncu Konuşmalar’ artık İzmir sınırlarını
            da aşacak farkındalığı yaymak için Anadolu’dan başlayarak Türkiye’yi
            dolaşacak.
            <br />
            <br />
            <b>Aromsa</b>
            <br />
            <br />Geçtiğimiz anneler gününde bütün çalışanlarına kadın el emeği
            grubunun ürettiği elle yapılmış kumaş anahtarlıklar verdi. Bu
            şekilde kadın emeğinin görünürlüğü ve desteklenmesi konusunda hem
            çalışanları için bir farkındalık oluşturdu, hem de kadınların
            üretimine doğrudan katkı sağladı.
            <br />
            <br />
            <b>Alışan Lojistik</b>
            <br />
            <br />Kendi bünyesinde kadın forklift operatörü yetiştirdi.
            <br />
            <br />
            <b>Altunbilekler</b>
            <br />
            <br />“Yönetimin Cinsiyeti Olmaz” Platformundaki çalışmaları
            sürüyor. Aynı zamanda şubelerinde “Mutfak Anneleri” isminde bir
            proje yürütüyor. Ankara genelindeki 72 mağazasında istihdam edilen
            mutfak anneleri, daha önce çalışanlar tarafından dönüşümlü olarak
            yapılan yemek servisi, bulaşık yıkama, çay demleme gibi
            sorumlulukları üstlendi. Anne şefkatini, işyerlerine yerleştirmeyi
            amaçlayan projede, istekli olanlar başka birimlere geçiş yapıp,
            görevlerinde yükselebiliyor. Markette ‘usta-çırak’ geleneğinin
            yeniden canlandırıldığı Yetkin Çalışan ve Performans Yönetimi
            Projesi ile bu yıl gerçekleştirilen Yerel Zincirler Buluşması’nda En
            iyi İnsan Kaynakları alanında “Perakendenin En İyi Fikirleri”
            ödülünü aldı.
            <br />
            <br />
            <b>Sodexo</b>
            <br />
            <br />Kadın aşçıları destekledikleri “Geleceğin Aşçıları” projesini
            hayata geçirdi. meslek lisesindeki kızları alıyorlar, eğitim
            veriyorlar, sonrasında meslek lisesinde mutfakla ilgili o lisenin
            ihtiyaçlarını karşılıyorlar, kızlara eğitim veriyorlar.
            Sürdürülebilir bir eğitim projesi olan bu proje kapsamında, Fehmi
            Yılmaz Kız Mesleki ve Teknik Anadolu Lisesi'nde kurulan Sodexo
            Atölyesi'nde öğrencilere eğitim ve tedarik alanında destek olunuyor
            ve onlara Sodexo’da staj ve daha da önemlisi istihdam olanağı
            sunuluyor.
            <br />
            <br />
            Aynı zamanda Sodexo’da “Toplumsal Cinsiyete Duyarlı Bütçeleme”ye iyi
            bir örnek olarak kadın çalışanların yaşadıkları zorluklarda
            kullanılmak üzere bir bütçe ayrıldı. Bu bütçe ile şiddet gören, aile
            içerisinde sorunlar yaşayan kadınlara finansal destek sağlanarak
            onların hayatlarına devam edebilmesini mümkün kılacak bir destek
            sağlanıyor.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    this.$root.$emit("loaded");
  }
};
</script>

<style></style>
